import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable()
export class TmsAmbarBlokService {
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
    public ambarCode : number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}



  getData(code: number,control:any,ambarCode: number, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);
    } 
    else{
      // DKM yok — QA3w/3x Clara: ctl-tms-ambar kalıbı — ilk ngOnChanges'te `control` yüklü
      // olmadığı için `baseEntity` tanımsız gelebiliyor; erken çık (davranış değişmiyor,
      // ngOnInit'teki getControl yanıtı getData'yı zaten tekrarlıyor).
      if(!baseEntity){
        return null
      }
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select([]);
    if (ambarCode) filterArr.push(['AmbarKod', '=', ambarCode]);
    }

    if(code)filterArr.push(['Kod', '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
